// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1QEuC","col":"styles_col__2k4nK","fulfillmentStatus":"styles_fulfillmentStatus__3X9hX","emailCol":"styles_emailCol__1LC6n"};